<template>
  <div v-if="carousel">
    <div
      id="products-carousel"
      class="carousel slide"
      data-ride="carousel"
      data-interval="3000">
      <div class="carousel-inner" role="listbox">
        <div :class="deck.active ? 'carousel-item active' : 'carousel-item'" role="listitem" v-for="deck in decks" v-bind:key="deck.key">
          <div class="row">
            <div class="col-md-4" v-for="product in deck.docs" v-bind:key="product._id">
              <Product :item="product" :share="false" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else>
    <b-card-group
      v-for="deck in decks"
      v-bind:key="deck.key"
      :class="deck.key > 0 ? 'mt-5': ''"
      deck>
      <Product
        v-for="product in deck.docs"
        v-bind:key="product._id"
        :readonlyRating="productProps.readonlyRating"
        :subtitleVariant="productProps.subtitleVariant"
        :item="product" />
    </b-card-group>
  </div>
</template>

<script>
import Product from '@/components/Product'

export default {
  name: 'DeckProducts',
  components: { Product },
  props: {
    productProps: {
      type: Object,
      default: () => ({ readonlyRating: false })
    },
    carouselProps: {
      type: Object,
      default: () => ({})
    },
    products: { type: Array, default: () => [] },
    quantity: { type: Number, default: () => 4 },
    carousel: { type: Boolean, default: () => false }
  },
  data () {
    return {
      decks: []
    }
  },
  watch: {
    products: function (value) {
      this.groupByDeck(this.products, this.quantity)
    }
  },
  methods: {
    groupByDeck (docs, quantity) {
      let currentIndex = 0
      const decks = docs.reduce((acc, item) => {
        if (acc[currentIndex].docs.length >= quantity) {
          currentIndex += 1
          acc[currentIndex] = { key: currentIndex, active: false, docs: [] }
        }
        acc[currentIndex].docs.push(item)
        return acc
      }, [{ key: 0, active: true, docs: [] }])
      this.decks = decks
    }
  }
}
</script>
